import React from "react";
import PropTypes from "prop-types";
import AlertMessage from "../../AlertMessage";
import { AlertMessageTypes } from '../../../constants/index';
import useContainerProps from '../../../hooks/useContainerProps';

/** This component renders all messages */
const MessagesModule = props => {
  props = useContainerProps(props);
  const { clearMessages, errorMessage, successMessage } = props;

  const renderAlertMessage = (message, messageType) => {
    if (!message) {
      return null;
    }
    return (
      <AlertMessage message={message} messageType={messageType}
        visible={message} clearMessages={clearMessages} />
    );
  };

  return (
    <>
      {renderAlertMessage(errorMessage, AlertMessageTypes.danger)}
      {renderAlertMessage(successMessage, AlertMessageTypes.success)}
    </>
  );
};

MessagesModule.propTypes = {
  clearMessages: PropTypes.func,
  errorMessage: PropTypes.string,
  successMessage: PropTypes.string
};

export default MessagesModule;
